// Friendly extraction of a string message from an `unknown` thrown
// value. TypeScript's `catch (e)` binds `e` as `unknown` (default since
// TS 4.4 + project's strict flags per D-006), forcing a defensive check
// before reading `.message`.
//
// **Why a helper, not the inline ternary.** Five call sites across the
// app shell at P-033 close (preview-iframe `useMemo` catch +
// OutputToolbar's renderEmail / Copy / Download / View handlers); per
// the project's 3-use threshold (D-067 / D-072 / D-077 / D-094) the
// hoist lands now. Two shapes were used inline:
// - `String(e)` fallback for the `RenderResult.error` case where the
//   raw stringified value is meaningful diagnostics.
// - Literal-string fallback (`'Copy failed'`, `'Download failed'`,
//   `'Could not open tab'`) for the user-status-text case where the
//   raw stringified non-Error value would read as gibberish to the
//   chapter staff editor.
//
// The optional `fallback` arg covers both — pass nothing for the
// String(e) shape, pass a friendly literal for the user-message shape.

export function errorMessage(e: unknown, fallback?: string): string {
  if (e instanceof Error) return e.message
  return fallback ?? String(e)
}
